import { Link } from "react-router-dom";
import { ArrowUpRight, Instagram, Linkedin } from "lucide-react";
import { Logo } from "./Logo";
import { useContent } from "../../context/ContentContext";

export const Footer = () => {
  const { site } = useContent();
  const c = site.contact || {};
  const logos = site.logos || {};
  const social = site.social || {};
  return (
    <footer className="border-t border-white/10 bg-korio-bg" data-testid="site-footer">
      <div className="mx-auto max-w-[1400px] px-6 py-20 md:px-10">
        <div className="grid gap-16 md:grid-cols-[1.5fr_1fr_1fr]">
          <div>
            <Logo variant="white" whiteSrc={logos.name_white} />
            <p className="mt-6 max-w-sm text-white/50">{site.footerBlurb}</p>
            <a
              href={`mailto:${c.email}`}
              data-testid="footer-email"
              className="mt-8 inline-flex items-center gap-2 font-display text-2xl text-white transition-colors hover:text-volt"
            >
              {c.email} <ArrowUpRight size={22} />
            </a>
            <div className="mt-8 flex items-center gap-3">
              <a href={social.instagram || "#"} target="_blank" rel="noreferrer" aria-label="Instagram" data-testid="footer-instagram"
                className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-white/60 transition-colors duration-300 hover:border-white/40 hover:text-white">
                <Instagram size={18} />
              </a>
              <a href={social.linkedin || "#"} target="_blank" rel="noreferrer" aria-label="LinkedIn" data-testid="footer-linkedin"
                className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-white/60 transition-colors duration-300 hover:border-white/40 hover:text-white">
                <Linkedin size={18} />
              </a>
            </div>
          </div>

          <div>
            <div className="mb-5 text-xs font-bold uppercase tracking-[0.2em] text-volt">Navigate</div>
            <ul className="space-y-3 text-white/60">
              <li><Link to="/about" className="hover:text-white">About</Link></li>
              <li><Link to="/services" className="hover:text-white">Services</Link></li>
              <li><Link to="/products" className="hover:text-white">Products</Link></li>
              <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
            </ul>
          </div>

          <div>
            <div className="mb-5 text-xs font-bold uppercase tracking-[0.2em] text-volt">Studio</div>
            <address className="space-y-1 not-italic text-white/60">
              <div className="text-white">{c.company}</div>
              {(c.address || []).map((line) => <div key={line}>{line}</div>)}
              <a href={c.phoneHref} className="block pt-2 hover:text-white">{c.phone}</a>
              <div className="pt-2 text-white/40">{c.vat}</div>
            </address>
          </div>
        </div>

        <div className="mt-16 flex flex-col gap-4 border-t border-white/10 pt-8 md:flex-row md:items-center md:justify-between">
          <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-white/40">
            <span>© {new Date().getFullYear()} {c.company || "KORIO SRL"}. All rights reserved.</span>
            <Link to="/privacy-policy" data-testid="footer-privacy-link" className="hover:text-white">Privacy Policy</Link>
          </div>
          <span className="font-mono text-xs uppercase tracking-widest text-white/50">{site.slogan}</span>
        </div>
      </div>
    </footer>
  );
};
